import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box } from "@mui/system";
import { useContext, useEffect } from "react";
import { AuthContext } from "../providers/AuthContextProvider";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { TenantEventContext } from "..";
export var LoginScreen = function () {
    var authContext = useContext(AuthContext);
    var _a = useContext(TenantEventContext), tenantId = _a.tenantId, eventId = _a.eventId;
    var navigate = useNavigate();
    useEffect(function () {
        if (authContext.isAuthenticated) {
            console.log("navigate to: /start");
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/start"));
        }
    }, [authContext.isAuthenticated, navigate]);
    return (_jsx(Box, { children: _jsx(CircularProgress, {}) }));
};
